import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface InitState {
  subAdminList: any
  loading: boolean
  error: boolean
}

const initialState: InitState = {
  subAdminList: { loading: true, data: [], count: 0 },
  loading: false,
  error: false,
}

export const subAdminDucks: any = createSlice({
  name: 'subAdmin',
  initialState,
  reducers: {
    getSubAdminList: (state: InitState) => {
      state.subAdminList = { loading: true }
    },
    getSubAdminListSuccess: (state: InitState, action: PayloadAction<any>) => {
      state.subAdminList = { loading: false, ...action.payload }
    },
    getSubAdminListFail: (state: InitState, action: PayloadAction<any>) => {
      state.subAdminList = { loading: false, error: true, ...action.payload }
    },
    assignSubAdmin: (state: InitState) => {
      state.loading = true
      state.error = false
    },
    assignSubAdminSuccess: (state: InitState) => {
      state.loading = false
    },
    assignSubAdminFail: (state: InitState) => {
      state.loading = false
      state.error = true
    },
    removeSubAdminHeThong: (state: InitState) => {
      state.loading = true
      state.error = false
    },
    removeSubAdminHeThongSuccess: (state: InitState) => {
      state.loading = false
    },
    removeSubAdminHeThongFail: (state: InitState) => {
      state.loading = false
      state.error = true
    },
    removeSubAdmin: (state: InitState) => {
      state.loading = true
      state.error = false
    },
    removeSubAdminSuccess: (state: InitState) => {
      state.loading = false
    },
    removeSubAdminFail: (state: InitState) => {
      state.loading = false
      state.error = true
    },
  },
})

export const {
  getSubAdminList,
  getSubAdminListSuccess,
  getSubAdminListFail,
  assignSubAdmin,
  assignSubAdminSuccess,
  assignSubAdminFail,
  removeSubAdminHeThong,
  removeSubAdminHeThongSuccess,
  removeSubAdminHeThongFail,
  removeSubAdmin,
  removeSubAdminSuccess,
  removeSubAdminFail,
} = subAdminDucks.actions

export default subAdminDucks.reducer